import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getProductsWithWhere } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useSWRProducts = (where: WHERE[] | null) => {
  const {
    data: products,
    isLoading,
    error,
    mutate,
  } = useSWR(where ? `products-${where.join('&')}` : null, () => getProductsWithWhere(where as WHERE[]), {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    products,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRProducts;
